import { ArrowLeftOutlined, CaretRightOutlined } from "@ant-design/icons";
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Collapse,
  Divider,
  Form,
  Input,
  Row,
  Select,
  Space,
  Switch,
  theme,
} from "antd";
import { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Heading from "../../../../components/common/heading";
import FailModal from "../../../../components/modal/failModal";
import SuccessModal from "../../../../components/modal/successModal";
import {
  DATA_MASTER_DATA_TYPE,
  PERMISSION,
  SUCCESS_CODE,
} from "../../../../lib/const";
import useCancelModal from "../../../../lib/hooks/useCancelModal";
import useMasterData from "../../../../lib/hooks/useMasterData";
import { routes } from "../../../../routes";
import {
  createRole,
  initAuthorizeRole,
} from "../../../../services/roleService";
import WithSidebar from "../../../../templates/withSidebar";
import "../../style.css";

const { Panel } = Collapse;
const { TextArea } = Input;

const Options = {
  create: "สร้าง",
  edit: "แก้ไข",
  delete: "ลบ",
  watch: "ดู",
  export: "Export JPG",
};

const appOptions = {
  create: "สร้าง",
  edit: "แก้ไข",
  delete: "ลบ",
  watch: "ดู",
  export: "Export Excel",
};

const CheckboxGroup = Checkbox.Group;

const applicationOptions = [
  appOptions.create,
  appOptions.edit,
  appOptions.delete,
  appOptions.watch,
  appOptions.export,
];

const plainOptions = [
  Options.create,
  Options.edit,
  Options.delete,
  Options.watch,
];

const dashboardOptions = [Options.watch, Options.export];

const panelStyle = {
  marginBottom: 24,
  // background: "#EBF5FF",
  borderRadius: "16px",
  border: "none",
};

const AddUserRoleManagement = () => {
  const navigate = useNavigate();
  const { token } = theme.useToken();
  const { setOpenCancelModal, setPreviousPage } = useCancelModal();
  const { Option } = Select;
  const [form] = Form.useForm();

  const [initPermission, setInitPermission] = useState([]);
  const [permissions] = useMasterData(DATA_MASTER_DATA_TYPE, PERMISSION);
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [openFailModal, setOpenFailModal] = useState(false);

  //กรอกผ่าน Application
  const [checkedListApp1, setCheckedListApp1] = useState([]);
  const [checkedListApp2, setCheckedListApp2] = useState([]);
  const [checkedListApp3, setCheckedListApp3] = useState([]);
  const [checkedListApp4, setCheckedListApp4] = useState([]);
  const [checkAllApp1, setCheckAllApp1] = useState(false);
  const [checkAllApp2, setCheckAllApp2] = useState(false);
  const [checkAllApp3, setCheckAllApp3] = useState(false);
  const [checkAllApp4, setCheckAllApp4] = useState(false);
  const [checkAllEstate1, setCheckAllEstate1] = useState(false);
  const [indeterminateApp1, setIndeterminateApp1] = useState(false);
  const [indeterminateApp2, setIndeterminateApp2] = useState(false);
  const [indeterminateApp3, setIndeterminateApp3] = useState(false);
  const [indeterminateApp4, setIndeterminateApp4] = useState(false);
  const [viewApp5, setViewApp5] = useState(false);
  const [viewApp6, setViewApp6] = useState(false);
  const [createEditApp5, setCreateEditApp5] = useState(false);
  const [createEditApp6, setCreateEditApp6] = useState(false);
  const [allYearOfBudgetApp5, setAllYearOfBudgetApp5] = useState(false);
  const [allYearOfBudgetApp6, setAllYearOfBudgetApp6] = useState(false);

  const [checkExportPDFApp7, setCheckExportPDFApp7] = useState(false);
  const [checkExportPDFApp8, setCheckExportPDFApp8] = useState(false);

  //นำเข้าข้อมูล Raw Data
  const [checkedListRawData1, setCheckedListRawData1] = useState([]);
  const [checkedListRawData2, setCheckedListRawData2] = useState([]);
  const [checkAllRawData1, setCheckAllRawData1] = useState(false);
  const [checkAllRawData2, setCheckAllRawData2] = useState(false);
  const [indeterminateRawData1, setIndeterminateRawData1] = useState(false);
  const [indeterminateRawData2, setIndeterminateRawData2] = useState(false);

  //ค้นหา/แก้ไขข้อมูล
  const [checkedListAction1, setCheckedListAction1] = useState([]);
  const [checkedListAction2, setCheckedListAction2] = useState([]);
  const [indeterminateAction1, setIndeterminateAction1] = useState(false);
  const [indeterminateAction2, setIndeterminateAction2] = useState(false);
  const [checkAllAction1, setCheckAllAction1] = useState(false);
  const [checkAllAction2, setCheckAllAction2] = useState(false);

  //Dashboard
  const [checkedListDashboard1, setCheckedListDashboard1] = useState([]);
  const [checkedListDashboard2, setCheckedListDashboard2] = useState([]);
  const [checkedListDashboard3, setCheckedListDashboard3] = useState([]);
  const [checkedListDashboard4, setCheckedListDashboard4] = useState([]);
  const [checkedListDashboard5, setCheckedListDashboard5] = useState([]);
  const [indeterminateDashboard1, setIndeterminateDashboard1] = useState(false);
  const [indeterminateDashboard2, setIndeterminateDashboard2] = useState(false);
  const [indeterminateDashboard3, setIndeterminateDashboard3] = useState(false);
  const [indeterminateDashboard4, setIndeterminateDashboard4] = useState(false);
  const [indeterminateDashboard5, setIndeterminateDashboard5] = useState(false);
  const [checkAllDashboard1, setCheckAllDashboard1] = useState(false);
  const [checkAllDashboard2, setCheckAllDashboard2] = useState(false);
  const [checkAllDashboard3, setCheckAllDashboard3] = useState(false);
  const [checkAllDashboard4, setCheckAllDashboard4] = useState(false);
  const [checkAllDashboard5, setCheckAllDashboard5] = useState(false);

  const [loading, setLoading] = useState(false);
  const [submittable, setSubmittable] = useState(false);

  const [displayEnable, setDisplayEnable] = useState(false);
  const values = Form.useWatch([], form);

  const onFinish = async (values) => {
    const request = {
      requestObject: {
        roleNameEn: values?.roleNameEn || "",
        roleNameTh: values?.roleNameTh,
        permissionId: values?.permission,
        description: values?.description,
        recStatus: values?.status ? "A" : "D",
        authorization: [
          {
            authorizeNameEn: "Current Customer",
            authorizeNameTh: "ข้อมูลลูกค้าปัจจุบัน",
            authorizeTopicId: "1cdf4ad0-8c1f-f4db-8965-26606ffa8ed1",
            permission: [
              {
                permissionNameEn: "Create",
                permissionNameTh: "สร้าง",
                isSelected:
                  checkedListApp1 && checkedListApp1.includes("สร้าง")
                    ? true
                    : false,
              },
              {
                permissionNameEn: "Edit",
                permissionNameTh: "แก้ไข",
                isSelected: checkedListApp1.includes("แก้ไข") ? true : false,
              },
              {
                permissionNameEn: "Delete",
                permissionNameTh: "ลบ",
                isSelected: checkedListApp1.includes("ลบ") ? true : false,
              },
              {
                permissionNameEn: "View",
                permissionNameTh: "ดู",
                isSelected: checkedListApp1.includes("ดู") ? true : false,
              },
              {
                permissionNameEn: "Export Excel",
                permissionNameTh: "Export Excel",
                isSelected: checkedListApp1.includes("Export Excel")
                  ? true
                  : false,
              },
              {
                permissionNameEn: "All",
                permissionNameTh: "ทำได้ทั้งหมด",
                isSelected: checkAllApp1,
              },
              {
                permissionNameEn: "Access all estates",
                permissionNameTh: "เข้าถึงข้อมูลทุกนิคมได้",
                isSelected: checkAllEstate1,
              },
            ],
          },
          {
            authorizeNameEn: "Future Customer",
            authorizeNameTh: "ข้อมูลลูกค้าอนาคต",
            authorizeTopicId: "1cdf4ad0-8c1f-f4db-8965-26606ffa8ed1",
            permission: [
              {
                permissionNameEn: "Create",
                permissionNameTh: "สร้าง",
                isSelected: checkedListApp2.includes("สร้าง") ? true : false,
              },
              {
                permissionNameEn: "Edit",
                permissionNameTh: "แก้ไข",
                isSelected: checkedListApp2.includes("แก้ไข") ? true : false,
              },
              {
                permissionNameEn: "Delete",
                permissionNameTh: "ลบ",
                isSelected: checkedListApp2.includes("ลบ") ? true : false,
              },
              {
                permissionNameEn: "View",
                permissionNameTh: "ดู",
                isSelected: checkedListApp2.includes("ดู") ? true : false,
              },
              {
                permissionNameEn: "Export Excel",
                permissionNameTh: "Export Excel",
                isSelected: checkedListApp1.includes("Export Excel")
                  ? true
                  : false,
              },
              {
                permissionNameEn: "All",
                permissionNameTh: "ทำได้ทั้งหมด",
                isSelected: checkAllApp2 ? true : false,
              },
            ],
          },
          {
            authorizeNameEn: "Touch Point Data",
            authorizeNameTh: "ข้อมูล Touch Point",
            authorizeTopicId: "1cdf4ad0-8c1f-f4db-8965-26606ffa8ed1",
            permission: [
              {
                permissionNameEn: "Create",
                permissionNameTh: "สร้าง",
                isSelected: checkedListApp3.includes("สร้าง") ? true : false,
              },
              {
                permissionNameEn: "Edit",
                permissionNameTh: "แก้ไข",
                isSelected: checkedListApp3.includes("แก้ไข") ? true : false,
              },
              {
                permissionNameEn: "Delete",
                permissionNameTh: "ลบ",
                isSelected: checkedListApp3.includes("ลบ") ? true : false,
              },
              {
                permissionNameEn: "View",
                permissionNameTh: "ดู",
                isSelected: checkedListApp3.includes("ดู") ? true : false,
              },
              {
                permissionNameEn: "All",
                permissionNameTh: "ทำได้ทั้งหมด",
                isSelected: checkAllApp3 ? true : false,
              },
            ],
          },
          {
            authorizeNameEn: "Stake Holders Data",
            authorizeNameTh: "ข้อมูลผู้มีส่วนได้ส่วนเสีย",
            authorizeTopicId: "1cdf4ad0-8c1f-f4db-8965-26606ffa8ed1",
            permission: [
              {
                permissionNameEn: "Create",
                permissionNameTh: "สร้าง",
                isSelected: checkedListApp4.includes("สร้าง") ? true : false,
              },
              {
                permissionNameEn: "Edit",
                permissionNameTh: "แก้ไข",
                isSelected: checkedListApp4.includes("แก้ไข") ? true : false,
              },
              {
                permissionNameEn: "Delete",
                permissionNameTh: "ลบ",
                isSelected: checkedListApp4.includes("ลบ") ? true : false,
              },
              {
                permissionNameEn: "View",
                permissionNameTh: "ดู",
                isSelected: checkedListApp4.includes("ดู") ? true : false,
              },
              {
                permissionNameEn: "All",
                permissionNameTh: "ทำได้ทั้งหมด",
                isSelected: checkAllApp4 ? true : false,
              },
            ],
          },
          {
            authorizeNameEn: "Satisfaction Data",
            authorizeNameTh: "ข้อมูลความพึงพอใจ",
            authorizeTopicId: "0dde5e71-42a7-f39c-8d63-1c855b36d07a",
            permission: [
              {
                permissionNameEn: "Create",
                permissionNameTh: "สร้าง",
                isSelected: checkedListRawData1.includes("สร้าง")
                  ? true
                  : false,
              },
              {
                permissionNameEn: "Edit",
                permissionNameTh: "แก้ไข",
                isSelected: checkedListRawData1.includes("แก้ไข")
                  ? true
                  : false,
              },
              {
                permissionNameEn: "Delete",
                permissionNameTh: "ลบ",
                isSelected: checkedListRawData1.includes("ลบ") ? true : false,
              },
              {
                permissionNameEn: "View",
                permissionNameTh: "ดู",
                isSelected: checkedListRawData1.includes("ดู") ? true : false,
              },
              {
                permissionNameEn: "All",
                permissionNameTh: "ทำได้ทั้งหมด",
                isSelected: checkAllRawData1 ? true : false,
              },
            ],
          },
          {
            authorizeNameEn: "Master Data",
            authorizeNameTh: "ข้อมูล Master Data",
            authorizeTopicId: "0dde5e71-42a7-f39c-8d63-1c855b36d07a",
            permission: [
              {
                permissionNameEn: "Create",
                permissionNameTh: "สร้าง",
                isSelected: checkedListRawData2.includes("สร้าง")
                  ? true
                  : false,
              },
              {
                permissionNameEn: "Edit",
                permissionNameTh: "แก้ไข",
                isSelected: checkedListRawData2.includes("แก้ไข")
                  ? true
                  : false,
              },
              {
                permissionNameEn: "Delete",
                permissionNameTh: "ลบ",
                isSelected: checkedListRawData2.includes("ลบ") ? true : false,
              },
              {
                permissionNameEn: "View",
                permissionNameTh: "ดู",
                isSelected: checkedListRawData2.includes("ดู") ? true : false,
              },
              {
                permissionNameEn: "All",
                permissionNameTh: "ทำได้ทั้งหมด",
                isSelected: checkAllRawData2 ? true : false,
              },
            ],
          },
          {
            authorizeNameEn: "Current Customer",
            authorizeNameTh: "ข้อมูลลูกค้าปัจจุบัน",
            authorizeTopicId: "f15f9069-71d0-a6e3-29a7-121206554679",
            permission: [
              {
                permissionNameEn: "Create",
                permissionNameTh: "สร้าง",
                isSelected: checkedListAction1.includes("สร้าง") ? true : false,
              },
              {
                permissionNameEn: "Edit",
                permissionNameTh: "แก้ไข",
                isSelected: checkedListAction1.includes("แก้ไข") ? true : false,
              },
              {
                permissionNameEn: "Delete",
                permissionNameTh: "ลบ",
                isSelected: checkedListAction1.includes("ลบ") ? true : false,
              },
              {
                permissionNameEn: "View",
                permissionNameTh: "ดู",
                isSelected: checkedListAction1.includes("ดู") ? true : false,
              },
              {
                permissionNameEn: "Export Excel",
                permissionNameTh: "Export Excel",
                isSelected: checkedListAction1.includes("นำออกข้อมูล")
                  ? true
                  : false,
              },
              {
                permissionNameEn: "All",
                permissionNameTh: "ทำได้ทั้งหมด",
                isSelected: checkAllAction1 ? true : false,
              },
            ],
          },
          {
            authorizeNameEn: "Future Customer",
            authorizeNameTh: "ข้อมูลลูกค้าอนาคต",
            authorizeTopicId: "f15f9069-71d0-a6e3-29a7-121206554679",
            permission: [
              {
                permissionNameEn: "Create",
                permissionNameTh: "สร้าง",
                isSelected: checkedListAction2.includes("สร้าง") ? true : false,
              },
              {
                permissionNameEn: "Edit",
                permissionNameTh: "แก้ไข",
                isSelected: checkedListAction2.includes("แก้ไข") ? true : false,
              },
              {
                permissionNameEn: "Delete",
                permissionNameTh: "ลบ",
                isSelected: checkedListAction2.includes("ลบ") ? true : false,
              },
              {
                permissionNameEn: "View",
                permissionNameTh: "ดู",
                isSelected: checkedListAction2.includes("ดู") ? true : false,
              },
              {
                permissionNameEn: "Export Excel",
                permissionNameTh: "Export Excel",
                isSelected: checkedListAction2.includes("นำออกข้อมูล")
                  ? true
                  : false,
              },
              {
                permissionNameEn: "All",
                permissionNameTh: "ทำได้ทั้งหมด",
                isSelected: checkAllAction2 ? true : false,
              },
            ],
          },
          {
            authorizeNameEn: "Current Customer",
            authorizeNameTh: "ข้อมูลลูกค้าปัจจุบัน",
            authorizeTopicId: "b9d77677-8a83-4059-6b91-1ec9b2803acb",
            permission: [
              {
                permissionNameEn: "View",
                permissionNameTh: "ดู",
                isSelected: checkedListDashboard1.includes("ดู") ? true : false,
              },
              {
                permissionNameEn: "Export JPG",
                permissionNameTh: "นำออกข้อมูล",
                isSelected: checkedListDashboard1.includes("นำออกข้อมูล")
                  ? true
                  : false,
              },
              {
                permissionNameEn: "All",
                permissionNameTh: "ทำได้ทั้งหมด",
                isSelected: checkAllDashboard1 ? true : false,
              },
            ],
          },
          {
            authorizeNameEn: "Future Customer",
            authorizeNameTh: "ข้อมูลลูกค้าอนาคต",
            authorizeTopicId: "b9d77677-8a83-4059-6b91-1ec9b2803acb",
            permission: [
              {
                permissionNameEn: "View",
                permissionNameTh: "ดู",
                isSelected: checkedListDashboard2.includes("ดู") ? true : false,
              },
              {
                permissionNameEn: "Export JPG",
                permissionNameTh: "นำออกข้อมูล",
                isSelected: checkedListDashboard2.includes("นำออกข้อมูล")
                  ? true
                  : false,
              },
              {
                permissionNameEn: "All",
                permissionNameTh: "ทำได้ทั้งหมด",
                isSelected: checkAllDashboard2 ? true : false,
              },
            ],
          },
          {
            authorizeNameEn: "Customer Visit",
            authorizeNameTh: "Customer Visit",
            authorizeTopicId: "b9d77677-8a83-4059-6b91-1ec9b2803acb",
            permission: [
              {
                permissionNameEn: "View",
                permissionNameTh: "ดู",
                isSelected: checkedListDashboard3.includes("ดู") ? true : false,
              },
              {
                permissionNameEn: "Export JPG",
                permissionNameTh: "นำออกข้อมูล",
                isSelected: checkedListDashboard3.includes("นำออกข้อมูล")
                  ? true
                  : false,
              },
              {
                permissionNameEn: "All",
                permissionNameTh: "ทำได้ทั้งหมด",
                isSelected: checkAllDashboard3 ? true : false,
              },
            ],
          },
          {
            authorizeNameEn: "Complaint Analysis Report",
            authorizeNameTh: "Complaint Analysis Report",
            authorizeTopicId: "b9d77677-8a83-4059-6b91-1ec9b2803acb",
            permission: [
              {
                permissionNameEn: "View",
                permissionNameTh: "ดู",
                isSelected: checkedListDashboard4.includes("ดู") ? true : false,
              },
              {
                permissionNameEn: "Export JPG",
                permissionNameTh: "นำออกข้อมูล",
                isSelected: checkedListDashboard4.includes("นำออกข้อมูล")
                  ? true
                  : false,
              },
              {
                permissionNameEn: "All",
                permissionNameTh: "ทำได้ทั้งหมด",
                isSelected: checkAllDashboard4 ? true : false,
              },
            ],
          },
          {
            authorizeNameEn: "Customer Satisfaction Survey",
            authorizeNameTh: "Complaint Analysis Report",
            authorizeTopicId: "b9d77677-8a83-4059-6b91-1ec9b2803acb",
            permission: [
              {
                permissionNameEn: "View",
                permissionNameTh: "ดู",
                isSelected: checkedListDashboard5.includes("ดู") ? true : false,
              },
              {
                permissionNameEn: "Export JPG",
                permissionNameTh: "นำออกข้อมูล",
                isSelected: checkedListDashboard5.includes("นำออกข้อมูล")
                  ? true
                  : false,
              },
              {
                permissionNameEn: "All",
                permissionNameTh: "ทำได้ทั้งหมด",
                isSelected: checkAllDashboard5 ? true : false,
              },
            ],
          },
          {
            authorizeNameEn: "KPI Report",
            authorizeNameTh: "รายงานผลตัวชี้วัด",
            authorizeTopicId: "1cdf4ad0-8c1f-f4db-8965-26606ffa8ed1",
            permission: [
              {
                permissionNameEn: "Create/Update",
                permissionNameTh: "สร้าง/แก้ไข",
                isSelected: createEditApp5 ? true : false,
              },
              {
                permissionNameEn: "View",
                permissionNameTh: "ดู",
                isSelected: viewApp5 ? true : false,
              },
              {
                permissionNameEn: "Access all year of budget",
                permissionNameTh: "เข้าถึงข้อมูลทุกปีงบประมาณ",
                isSelected: allYearOfBudgetApp5 ? true : false,
              },
            ],
          },
          {
            authorizeNameEn: "Performance Report",
            authorizeNameTh: "รายงานผลการดำเนินงานตามแผนปฏิบัติการ",
            authorizeTopicId: "1cdf4ad0-8c1f-f4db-8965-26606ffa8ed1",
            permission: [
              {
                permissionNameEn: "Create/Update",
                permissionNameTh: "สร้าง/แก้ไข",
                isSelected: createEditApp6 ? true : false,
              },
              {
                permissionNameEn: "View",
                permissionNameTh: "ดู",
                isSelected: viewApp6 ? true : false,
              },
              {
                permissionNameEn: "Access all year of budget",
                permissionNameTh: "เข้าถึงข้อมูลทุกปีงบประมาณ",
                isSelected: allYearOfBudgetApp6 ? true : false,
              },
            ],
          },
          {
            authorizeNameEn: "VocReport CurrentCustomer",
            authorizeNameTh: "รายงานจัดอันดับลูกค้าปัจจุบัน",
            authorizeTopicId: "1cdf4ad0-8c1f-f4db-8965-26606ffa8ed1",
            permission: [
              {
                permissionNameEn: "Export PDF",
                permissionNameTh: "นำออกข้อมูล PDF",
                isSelected: checkExportPDFApp7 ? true : false,
              },
            ],
          },
          {
            authorizeNameEn: "VocReport FutureCustomer",
            authorizeNameTh: "รายงานจัดอันดับลูกค้าอนาคต",
            authorizeTopicId: "1cdf4ad0-8c1f-f4db-8965-26606ffa8ed1",
            permission: [
              {
                permissionNameEn: "Export PDF",
                permissionNameTh: "นำออกข้อมูล PDF",
                isSelected: checkExportPDFApp8 ? true : false,
              },
            ],
          },
        ],
      },
    };

    const res = await createRole(request);
    if (res?.data?.code === SUCCESS_CODE) {
      setOpenSuccessModal(true);

      setTimeout(() => {
        navigate(routes.user_management + `?menu=management&tab=role`);
      }, 2500);
    } else {
      setOpenFailModal(true);
    }

    setLoading(true);
    setTimeout(() => {
      closeLoader();
    }, 3000);
  };

  const closeLoader = useCallback(() => {
    setLoading(false);
    setOpenSuccessModal(false);
    setOpenFailModal(false);
  }, [setLoading, setOpenSuccessModal, setOpenFailModal]);

  const validateBeforeSubmit = useCallback(
    (values) => {
      if (values?.permission && values?.roleNameTh) {
        setSubmittable(true);
      } else {
        setSubmittable(false);
      }
    },
    [setSubmittable]
  );

  useEffect(() => {
    validateBeforeSubmit(values);
  }, [values, validateBeforeSubmit]);

  const initAuthorize = useCallback(async () => {
    const res = await initAuthorizeRole();
    if (res?.data?.code === SUCCESS_CODE) {
      const { objectValue } = res.data;
      setInitPermission(objectValue);
    }
  }, []);

  useEffect(() => {
    initAuthorize();
  }, [initAuthorize]);

  const onChangeStatus = (checked) => {};

  //กรอกผ่าน Application
  const onChangeListApp = (list, type) => {
    if (type === "app1") {
      setCheckedListApp1(list);
      setCheckAllApp1(list.length === applicationOptions.length);
    } else if (type === "app2") {
      setCheckedListApp2(list);
      setCheckAllApp2(list.length === applicationOptions.length);
    } else if (type === "app3") {
      setCheckedListApp3(list);
      setCheckAllApp3(list.length === plainOptions.length);
    } else {
      setCheckedListApp4(list);
      setCheckAllApp4(list.length === plainOptions.length);
    }
  };

  const onCheckAllAppChange = (e, type) => {
    if (type === "app1") {
      setCheckedListApp1(e.target.checked ? applicationOptions : []);
      setCheckAllApp1(e.target.checked);
    } else if (type === "app2") {
      setCheckedListApp2(e.target.checked ? applicationOptions : []);
      setCheckAllApp2(e.target.checked);
    } else if (type === "app3") {
      setCheckedListApp3(e.target.checked ? plainOptions : []);
      setCheckAllApp3(e.target.checked);
    } else {
      setCheckedListApp4(e.target.checked ? plainOptions : []);
      setCheckAllApp4(e.target.checked);
    }
  };

  const onChangeAllEstate = (list,type) => {
    if (type === "app1") {
      setCheckAllEstate1(list.target.checked);
    }
  }

  const onCheckCreateEditApp = (e,type) => {
    if (type === "app5") {
      setCreateEditApp5(e.target.checked);
    }else
    if (type === "app6") {
      setCreateEditApp6(e.target.checked);
    }
  }

  const onCheckViewApp = (e,type) => {
    if (type === "app5") {
      setViewApp5(e.target.checked);
    }else
    if (type === "app6") {
      setViewApp6(e.target.checked);
    }
  }

  const onCheckAllYearOfBudgetApp = (e,type) => {
    if (type === "app5") {
      setAllYearOfBudgetApp5(e.target.checked);
    }else 
    if (type === "app6") {
      setAllYearOfBudgetApp6(e.target.checked);
    }
  }

  const onCheckExportPDFApp = (e,type) =>{
    if (type === "app7"){
      setCheckExportPDFApp7(e.target.checked);
    }else
    if (type === "app8"){
      setCheckExportPDFApp8(e.target.checked);
    }
  }

  //นำเข้าข้อมูล Raw Data
  const onChangeListRawData = (list, type) => {
    if (type === "raw1") {
      setCheckedListRawData1(list);
      setCheckAllRawData1(list.length === plainOptions.length);
    } else {
      setCheckedListRawData2(list);
      setCheckAllRawData2(list.length === plainOptions.length);
    }
  };

  const onCheckAllRawDataChange = (e, type) => {
    if (type === "raw1") {
      setCheckedListRawData1(e.target.checked ? plainOptions : []);
      setCheckAllRawData1(e.target.checked);
    } else {
      setCheckedListRawData2(e.target.checked ? plainOptions : []);
      setCheckAllRawData2(e.target.checked);
    }
  };

  //Dashboard
  const onChangeListDashboard = (list, type) => {
    if (type === "dash1") {
      setCheckedListDashboard1(list);
      setCheckAllDashboard1(list.length === plainOptions.length);
    } else if (type === "dash2") {
      setCheckedListDashboard2(list);
      setCheckAllDashboard2(list.length === plainOptions.length);
    } else if (type === "dash3") {
      setCheckedListDashboard3(list);
      setCheckAllDashboard3(list.length === plainOptions.length);
    } else if (type === "dash4") {
      setCheckedListDashboard4(list);
      setCheckAllDashboard4(list.length === plainOptions.length);
    } else {
      setCheckedListDashboard5(list);
      setCheckAllDashboard5(list.length === plainOptions.length);
    }
  };

  const onCheckAllDashboardChange = (e, type) => {
    if (type === "dash1") {
      setCheckedListDashboard1(e.target.checked ? plainOptions : []);
      setCheckAllDashboard1(e.target.checked);
    } else if (type === "dash2") {
      setCheckedListDashboard2(e.target.checked ? plainOptions : []);
      setCheckAllDashboard2(e.target.checked);
    } else if (type === "dash3") {
      setCheckedListDashboard3(e.target.checked ? plainOptions : []);
      setCheckAllDashboard3(e.target.checked);
    } else if (type === "dash4") {
      setCheckedListDashboard4(e.target.checked ? plainOptions : []);
      setCheckAllDashboard4(e.target.checked);
    } else {
      setCheckedListDashboard5(e.target.checked ? plainOptions : []);
      setCheckAllDashboard5(e.target.checked);
    }
  };

  // on change of permission
  const onChangePermision = (value) => {
    if (!value && value === undefined) {
      setDisplayEnable(false);
    } else {
      setDisplayEnable(true);
    }

    if (value === "a23126cb-5ef4-0c98-e3bc-840d81135073") {
      //admin
      setCheckedListApp1([]);
      setCheckedListApp2([]);
      setCheckedListApp3([]);
      setCheckedListApp4([]);
      setCheckAllApp1(true);
      setCheckAllApp2(true);
      setCheckAllApp3(true);
      setCheckAllApp4(true);

      setCheckedListRawData1([]);
      setCheckedListRawData2([]);
      setCheckAllRawData1(true);
      setCheckAllRawData2(true);

      setCheckedListAction1([]);
      setCheckedListAction2([]);
      setCheckAllAction1(true);
      setCheckAllAction2(true);

      setCheckedListDashboard1([]);
      setCheckedListDashboard2([]);
      setCheckedListDashboard3([]);
      setCheckedListDashboard4([]);
      setCheckedListDashboard5([]);
      setCheckAllDashboard1(true);
      setCheckAllDashboard2(true);
      setCheckAllDashboard3(true);
      setCheckAllDashboard4(true);
      setCheckAllDashboard5(true);
    }
    if (value === "498a2cd4-2097-4337-7b92-9c84bc1411d3") {
      //nikom
      setCheckedListApp1([Options.create, Options.watch]);
      setCheckedListApp2([Options.create, Options.watch]);
      setCheckedListApp3([Options.create, Options.watch]);
      setCheckedListApp4([Options.create, Options.watch]);
      setCheckAllApp1(false);
      setCheckAllApp2(false);
      setCheckAllApp3(false);
      setCheckAllApp4(false);

      setCheckedListRawData1([Options.create, Options.watch]);
      setCheckedListRawData2([Options.create, Options.watch]);
      setCheckAllRawData1(false);
      setCheckAllRawData2(false);

      setCheckedListAction1([Options.create, Options.watch]);
      setCheckedListAction2([Options.create, Options.watch]);
      setCheckAllAction1(false);
      setCheckAllAction2(false);

      setCheckedListDashboard1([]);
      setCheckedListDashboard2([]);
      setCheckedListDashboard3([]);
      setCheckedListDashboard4([]);
      setCheckedListDashboard5([]);
      setCheckAllDashboard1(true);
      setCheckAllDashboard2(true);
      setCheckAllDashboard3(true);
      setCheckAllDashboard4(true);
      setCheckAllDashboard5(true);
    } else if (value === "13cb9f4a-0bb9-4f5e-b2ff-961d5e93c741") {
      //manager
      setCheckedListApp1([Options.watch]);
      setCheckedListApp2([Options.watch]);
      setCheckedListApp3([Options.watch]);
      setCheckedListApp4([Options.watch]);
      setCheckAllApp1(false);
      setCheckAllApp2(false);
      setCheckAllApp3(false);
      setCheckAllApp4(false);

      setCheckedListRawData1([Options.watch]);
      setCheckedListRawData2([Options.watch]);
      setCheckAllRawData1(false);
      setCheckAllRawData2(false);

      setCheckedListAction1([Options.watch]);
      setCheckedListAction2([Options.watch]);
      setCheckAllAction1(false);
      setCheckAllAction2(false);

      setCheckedListDashboard1([]);
      setCheckedListDashboard2([]);
      setCheckedListDashboard3([]);
      setCheckedListDashboard4([]);
      setCheckedListDashboard5([]);
      setCheckAllDashboard1(true);
      setCheckAllDashboard2(true);
      setCheckAllDashboard3(true);
      setCheckAllDashboard4(true);
      setCheckAllDashboard5(true);
    } else if (!value || value === undefined) {
      setCheckedListApp1([]);
      setCheckedListApp2([]);
      setCheckedListApp3([]);
      setCheckedListApp4([]);
      setCheckAllApp1(false);
      setCheckAllApp2(false);
      setCheckAllApp3(false);
      setCheckAllApp4(false);

      setCheckedListRawData1([]);
      setCheckedListRawData2([]);
      setCheckAllRawData1(false);
      setCheckAllRawData2(false);

      setCheckedListAction1([]);
      setCheckedListAction2([]);
      setCheckAllAction1(false);
      setCheckAllAction2(false);

      setCheckedListDashboard1([]);
      setCheckedListDashboard2([]);
      setCheckedListDashboard3([]);
      setCheckedListDashboard4([]);
      setCheckedListDashboard5([]);
      setCheckAllDashboard1(false);
      setCheckAllDashboard2(false);
      setCheckAllDashboard3(false);
      setCheckAllDashboard4(false);
      setCheckAllDashboard5(false);
    }
  };

  return (
    <WithSidebar>
      <div className="add_role_management">
        <Row gutter={[24, 24]} style={{ marginTop: 15 }}>
          <Col span={24} vertical="center">
            <div className="flex items-center">
              <Space size={12}>
                <Button
                  type="link"
                  onClick={() => {
                    setOpenCancelModal(true);
                    setPreviousPage(
                      routes.user_management + `?menu=management&tab=role`
                    );
                  }}
                  style={{ padding: 0 }}
                >
                  <ArrowLeftOutlined style={{ color: "#000", fontSize: 16 }} />
                </Button>
                <Heading text={"เพิ่มสิทธิ์"} size={4} style={{ margin: 0 }} />
              </Space>
            </div>
            <Breadcrumb
              style={{ paddingTop: 10 }}
              items={[
                {
                  title: "การจัดการผู้ใช้งาน",
                },
                {
                  title: (
                    <Link to={routes.user_management}>
                      การจัดการบทบาทและสิทธิ์การเข้าถึง
                    </Link>
                  ),
                },
                {
                  title: <span className="pr_green">เพิ่มสิทธิ์</span>,
                },
              ]}
            />
          </Col>

          <Form
            form={form}
            onFinish={onFinish}
            layout="vertical"
            style={{ width: "100%", padding: "0 30px" }}
            colon={false}
            initialValues={{
              status: true,
            }}
          >
            <Col span={24}>
              <Row gutter={[24, 16]} style={{ marginBottom: 10 }}>
                <Col span={24} align="right">
                  <Space>
                    <Button
                      onClick={() => {
                        setOpenCancelModal(true);
                        setPreviousPage(
                          routes.user_management + `?menu=management&tab=role`
                        );
                      }}
                    >
                      ยกเลิก
                    </Button>
                    <Button
                      type="primary"
                      htmlType="submit"
                      disabled={!submittable}
                      loading={loading}
                    >
                      บันทึก
                    </Button>
                  </Space>
                </Col>
              </Row>

              <Row gutter={[8]} className="card">
                <Col span={24}>
                  <Heading text={"กำหนดสิทธ์"} size={4} style={{ margin: 0 }} />
                  <Divider />
                </Col>
                <Col span={24}>
                  <Row gutter={[24, 18]}>
                    <Col span={8}>
                      <Form.Item
                        label="Permission"
                        name={"permission"}
                        rules={[{ required: true, message: "โปรดระบุ" }]}
                      >
                        <Select
                          allowClear
                          showSearch={false}
                          className="w-full"
                          placeholder="กรุณาเลือก Permission"
                          optionFilterProp="children"
                          onChange={onChangePermision}
                          hasfeedback="true"
                        >
                          {permissions?.map((option, i) => {
                            return (
                              <Option key={option.dataId} value={option.dataId}>
                                {option.dataDetailTh}
                              </Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        name={"roleNameTh"}
                        label="ชื่อ Role"
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <Input
                          placeholder="ชื่อ Role"
                          disabled={
                            !form.getFieldValue(["permission"]) ? true : false
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item label="สถานะ Role" name={"status"}>
                        <Switch
                          // defaultChecked
                          onChange={onChangeStatus}
                          checked={form.getFieldValue(["status"])}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item label="รายละเอียด Role" name={"description"}>
                        <TextArea rows={3} placeholder="รายละเอียด Role" />
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              </Row>
              {displayEnable && (
                <>
                  <Row gutter={[8]} className="card" style={{ marginTop: 15 }}>
                    <Col span={24}>
                      <Heading
                        text={"การกำหนดสิทธ์การเข้าถึง"}
                        size={4}
                        style={{ margin: 0 }}
                      />
                      <Divider />
                    </Col>
                    <Col span={24}>
                      <Collapse
                        bordered={false}
                        defaultActiveKey={["1"]}
                        expandIconPosition={"right"}
                        expandIcon={({ isActive }) => (
                          <CaretRightOutlined rotate={isActive ? 90 : 0} />
                        )}
                        style={{
                          background: token.colorBgContainer,
                        }}
                      >
                        <Panel
                          header={
                            <>
                              <span className="box-border"></span>กรอกผ่าน
                              Application
                            </>
                          }
                          key="1"
                          style={panelStyle}
                        >
                          <Row gutter={[24, 18]}>
                            <Col span={24}>
                              <Form.Item
                                label="ข้อมูลลูกค้าปัจจุบัน"
                                name={"app1"}
                              >
                                <CheckboxGroup
                                  options={applicationOptions}
                                  value={checkedListApp1}
                                  onChange={(event) => {
                                    onChangeListApp(event, "app1");
                                  }}
                                  disabled={checkAllApp1}
                                />
                                <Checkbox style={{ width: "140px" }}
                                  indeterminate={indeterminateApp1}
                                  onChange={(event) => {
                                    onCheckAllAppChange(event, "app1");
                                  }}
                                  checked={checkAllApp1}
                                >
                                  ทำได้ทั้งหมด
                                </Checkbox>

                                <Checkbox
                                  onChange={(event) => {
                                    onChangeAllEstate(event, "app1");
                                  }}
                                  checked={checkAllEstate1}
                                >
                                  เข้าถึงข้อมูลทุกนิคมได้
                                </Checkbox>
                              </Form.Item>
                            </Col>
                            <Col span={24}>
                              <Form.Item
                                label="ข้อมูลลูกค้าอนาคต"
                                name={"app2"}
                              >
                                <CheckboxGroup
                                  options={applicationOptions}
                                  value={checkedListApp2}
                                  onChange={(event) => {
                                    onChangeListApp(event, "app2");
                                  }}
                                  disabled={checkAllApp2}
                                />
                                <Checkbox
                                  indeterminate={indeterminateApp2}
                                  onChange={(event) => {
                                    onCheckAllAppChange(event, "app2");
                                  }}
                                  checked={checkAllApp2}
                                >
                                  ทำได้ทั้งหมด
                                </Checkbox>
                              </Form.Item>
                            </Col>
                            <Col span={24}>
                              <Form.Item
                                label="ข้อมูล Touch Point"
                                name={"app3"}
                              >
                                <CheckboxGroup
                                  options={plainOptions}
                                  value={checkedListApp3}
                                  onChange={(event) => {
                                    onChangeListApp(event, "app3");
                                  }}
                                  disabled={checkAllApp3}
                                />
                                <Checkbox
                                  indeterminate={indeterminateApp3}
                                  onChange={(event) => {
                                    onCheckAllAppChange(event, "app3");
                                  }}
                                  checked={checkAllApp3}
                                >
                                  ทำได้ทั้งหมด
                                </Checkbox>
                              </Form.Item>
                            </Col>
                            <Col span={24}>
                              <Form.Item
                                label="ข้อมูลผู้มีส่วนได้ส่วนเสีย"
                                name={"app4"}
                              >
                                <CheckboxGroup
                                  options={plainOptions}
                                  value={checkedListApp4}
                                  onChange={(event) => {
                                    onChangeListApp(event, "app4");
                                  }}
                                  disabled={checkAllApp4}
                                />
                                <Checkbox
                                  indeterminate={indeterminateApp4}
                                  onChange={(event) => {
                                    onCheckAllAppChange(event, "app4");
                                  }}
                                  checked={checkAllApp4}
                                >
                                  ทำได้ทั้งหมด
                                </Checkbox>
                              </Form.Item>
                            </Col>
                            <Col span={24}>
                              <Form.Item
                                label="รายงานผลตัวชี้วัด"
                                name={"app5"}
                              >
                                <Checkbox style={{ width: "140px" }}
                                  onChange={(event) => {
                                    onCheckCreateEditApp(event, "app5");
                                  }}
                                  checked={createEditApp5}
                                >
                                  สร้าง/แก้ไข
                                </Checkbox>

                                <Checkbox style={{ width: "140px" }}
                                  onChange={(event) => {
                                    onCheckViewApp(event, "app5");
                                  }}
                                  checked={viewApp5}
                                >
                                  ดู
                                </Checkbox>

                                <Checkbox
                                  onChange={(event) => {
                                    onCheckAllYearOfBudgetApp(event, "app5");
                                  }}
                                  checked={allYearOfBudgetApp5}
                                >
                                  เข้าถึงข้อมูลทุกปีงบประมาณ
                                </Checkbox>


                              </Form.Item>
                            </Col>
                            <Col span={24}>
                              <Form.Item
                                label="รายงานผลการดำเนินงานตามแผนปฏิบัติการ"
                                name={"app6"}
                              >
                                <Checkbox style={{ width: "140px" }}
                                  onChange={(event) => {
                                    onCheckCreateEditApp(event, "app6");
                                  }}
                                  checked={createEditApp6}
                                >
                                  สร้าง/แก้ไข
                                </Checkbox>

                                <Checkbox style={{ width: "140px" }}
                                  onChange={(event) => {
                                    onCheckViewApp(event, "app6");
                                  }}
                                  checked={viewApp6}
                                >
                                  ดู
                                </Checkbox>

                                <Checkbox
                                  onChange={(event) => {
                                    onCheckAllYearOfBudgetApp(event, "app6");
                                  }}
                                  checked={allYearOfBudgetApp6}
                                >
                                  เข้าถึงข้อมูลทุกปีงบประมาณ
                                </Checkbox>


                              </Form.Item>
                            </Col>
                            <Col span={24}>
                              <Form.Item
                                label="รายงานจัดอันดับลูกค้าปัจจุบัน"
                                name={"app7"}
                              >
                                <Checkbox style={{ width: "140px" }}
                                  onChange={(event) => {
                                    onCheckExportPDFApp(event, "app7");
                                  }}
                                  checked={checkExportPDFApp7}
                                >
                                  Export PDF
                                </Checkbox>
                              </Form.Item>
                            </Col>
                            <Col span={24}>
                              <Form.Item
                                label="รายงานจัดอันดับลูกค้าอนาคต"
                                name={"app8"}
                              >
                                <Checkbox style={{ width: "140px" }}
                                  onChange={(event) => {
                                    onCheckExportPDFApp(event, "app8");
                                  }}
                                  checked={checkExportPDFApp8}
                                >
                                  Export PDF
                                </Checkbox>
                              </Form.Item>
                            </Col>
                          </Row>
                        </Panel>

                        <Panel
                          header={
                            <>
                              <span className="box-border"></span>นำเข้าข้อมูล
                              Raw Data
                            </>
                          }
                          key="2"
                          style={panelStyle}
                        >
                          <Row gutter={[24, 18]}>
                            <Col span={24}>
                              <Form.Item
                                label="ข้อมูลความพึงพอใจ"
                                name={"raw1"}
                              >
                                <CheckboxGroup
                                  options={plainOptions}
                                  value={checkedListRawData1}
                                  onChange={(event) => {
                                    onChangeListRawData(event, "raw1");
                                  }}
                                  disabled={checkAllRawData1}
                                />
                                <Checkbox
                                  indeterminate={indeterminateRawData1}
                                  onChange={(event) => {
                                    onCheckAllRawDataChange(event, "raw1");
                                  }}
                                  checked={checkAllRawData1}
                                >
                                  ทำได้ทั้งหมด
                                </Checkbox>
                              </Form.Item>
                            </Col>
                            <Col span={24}>
                              <Form.Item
                                label="ข้อมูล Master Data"
                                name={"raw2"}
                              >
                                <CheckboxGroup
                                  options={plainOptions}
                                  value={checkedListRawData2}
                                  onChange={(event) => {
                                    onChangeListRawData(event, "raw2");
                                  }}
                                  disabled={checkAllRawData2}
                                />
                                <Checkbox
                                  indeterminate={indeterminateRawData2}
                                  onChange={(event) => {
                                    onCheckAllRawDataChange(event, "raw2");
                                  }}
                                  checked={checkAllRawData2}
                                >
                                  ทำได้ทั้งหมด
                                </Checkbox>
                              </Form.Item>
                            </Col>
                          </Row>
                        </Panel>
                        <Panel
                          header={
                            <>
                              <span className="box-border"></span>Dashboard
                            </>
                          }
                          key="4"
                          style={panelStyle}
                        >
                          <Row gutter={[24, 18]}>
                            <Col span={24}>
                              <Form.Item
                                label="ข้อมูลลูกค้าปัจจุบัน"
                                name={"dash1"}
                              >
                                <CheckboxGroup
                                  options={dashboardOptions}
                                  value={checkedListDashboard1}
                                  onChange={(event) => {
                                    onChangeListDashboard(event, "dash1");
                                  }}
                                  disabled={checkAllDashboard1}
                                />
                                <Checkbox
                                  indeterminate={indeterminateDashboard1}
                                  onChange={(event) => {
                                    onCheckAllDashboardChange(event, "dash1");
                                  }}
                                  checked={checkAllDashboard1}
                                >
                                  ทำได้ทั้งหมด
                                </Checkbox>
                              </Form.Item>
                            </Col>
                            <Col span={24}>
                              <Form.Item
                                label="ข้อมูลลูกค้าอนาคต"
                                name={"dash2"}
                              >
                                <CheckboxGroup
                                  options={dashboardOptions}
                                  value={checkedListDashboard2}
                                  onChange={(event) => {
                                    onChangeListDashboard(event, "dash2");
                                  }}
                                  disabled={checkAllDashboard2}
                                />
                                <Checkbox
                                  indeterminate={indeterminateDashboard2}
                                  onChange={(event) => {
                                    onCheckAllDashboardChange(event, "dash2");
                                  }}
                                  checked={checkAllDashboard2}
                                >
                                  ทำได้ทั้งหมด
                                </Checkbox>
                              </Form.Item>
                            </Col>
                            <Col span={24}>
                              <Form.Item label="Customer Visit" name={"dash3"}>
                                <CheckboxGroup
                                  options={dashboardOptions}
                                  value={checkedListDashboard3}
                                  onChange={(event) => {
                                    onChangeListDashboard(event, "dash3");
                                  }}
                                  disabled={checkAllDashboard3}
                                />
                                <Checkbox
                                  indeterminate={indeterminateDashboard3}
                                  onChange={(event) => {
                                    onCheckAllDashboardChange(event, "dash3");
                                  }}
                                  checked={checkAllDashboard3}
                                >
                                  ทำได้ทั้งหมด
                                </Checkbox>
                              </Form.Item>
                            </Col>
                            <Col span={24}>
                              <Form.Item
                                label="Complaint Analysis Report"
                                name={"dash4"}
                              >
                                <CheckboxGroup
                                  options={dashboardOptions}
                                  value={checkedListDashboard4}
                                  onChange={(event) => {
                                    onChangeListDashboard(event, "dash4");
                                  }}
                                  disabled={checkAllDashboard4}
                                />
                                <Checkbox
                                  indeterminate={indeterminateDashboard4}
                                  onChange={(event) => {
                                    onCheckAllDashboardChange(event, "dash4");
                                  }}
                                  checked={checkAllDashboard4}
                                >
                                  ทำได้ทั้งหมด
                                </Checkbox>
                              </Form.Item>
                            </Col>
                            <Col span={24}>
                              <Form.Item
                                label="Customer Satisfaction Survey"
                                name={"dash5"}
                              >
                                <CheckboxGroup
                                  options={dashboardOptions}
                                  value={checkedListDashboard5}
                                  onChange={(event) => {
                                    onChangeListDashboard(event, "dash5");
                                  }}
                                  disabled={checkAllDashboard5}
                                />
                                <Checkbox
                                  indeterminate={indeterminateDashboard5}
                                  onChange={(event) => {
                                    onCheckAllDashboardChange(event, "dash5");
                                  }}
                                  checked={checkAllDashboard5}
                                >
                                  ทำได้ทั้งหมด
                                </Checkbox>
                              </Form.Item>
                            </Col>
                          </Row>
                        </Panel>
                      </Collapse>
                    </Col>
                  </Row>
                </>
              )}
            </Col>
          </Form>
        </Row>

        <SuccessModal
          open={openSuccessModal}
          setOpen={setOpenSuccessModal}
          title="สำเร็จ"
          subTitle={"ทำรายการสำเร็จ"}
        />

        <FailModal open={openFailModal} setOpen={setOpenFailModal} />
      </div>
    </WithSidebar>
  );
};

export default AddUserRoleManagement;
